import { apiRequest } from "../util/apiUtils";

export const contactAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "put" : "post",
      `contact-us/${payload?.id ? "edit" : "add"}`,
      {
        body: payload,
      },
      "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const contactList = async (params) => {
  try {
    const res = await apiRequest("get", `contact-us/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const contactDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `contact-us/delete-all`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
